// Belopp och tal som byrån skriver i kronor, med mellanslag och komma.
// Katalogen sparar öre (ADR 0022).

/** "1 500" och "1500,50" blir öre. Annat blir null. */
export function lasKronor(text: string): number | null {
  const t = text.replace(/[\s\u00a0]/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null;
  return Math.round(Number(t) * 100);
}

/** 150000 öre blir "1 500", och 150050 blir "1 500,50". */
export function skrivKronor(ore: number): string {
  const kronor = ore / 100;
  return new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: Number.isInteger(kronor) ? 0 : 2,
    maximumFractionDigits: 2,
  })
    .format(kronor)
    .replace(/\u00a0/g, ' ');
}

/** Ett heltal, utan mellanslag. Annat blir null. */
export function lasHeltal(text: string): number | null {
  const t = text.replace(/[\s\u00a0]/g, '');
  return /^-?\d+$/.test(t) ? Number(t) : null;
}

/** Ett tal med decimaler, med komma eller punkt. Annat blir null. */
export function lasTal(text: string): number | null {
  const t = text.replace(/[\s\u00a0]/g, '').replace(',', '.');
  return /^\d+(\.\d+)?$/.test(t) ? Number(t) : null;
}

/** 0.5 blir "0,5". */
export function skrivTal(tal: number): string {
  return String(tal).replace('.', ',');
}
